<template>
  <div>
    <!-- Header -->
    <div class="header bg-home py-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">

          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <section id="intro-content">
      <div class="container">

        <base-progress style="width: 80%; margin: auto" show-label type="secondary" label="Progresso" :height="4" :value="progressValue" ></base-progress>
        <div class="py-4">
          <div class="icon-category">
            <div class="bg-home">
              <small>PERGUNTAS</small>
            </div>
          </div>
          <h2 class="display-3 pt-2">Parte 1</h2>
          <p class="lead">Coloque o seletor na posição que mais representa sua opinião sobre o que está sendo dito.</p>
          <p><b>ATENÇÃO:<br />Responda com sinceridade para obter o resultado mais adequado</b></p>
        </div>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <form id="qa1" class="needs-validation qa"
                @submit.prevent="handleSubmit(nextPage)">


            <div class="form-row">
              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Quando criança, nunca sonhei em ser médico, engenheiro,
                    advogado ou outra profissão tradicional.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p1.q1">
                </range-slider>
                <div class="marks ticks">
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
<!--                <div class="tickmarks">-->
<!--                  <div class="tick-left">-->
<!--                    <div class="tick"></div>-->
<!--                  </div>-->
<!--                  <div class="tick-left">-->
<!--                    <div class="tick"></div>-->
<!--                  </div>-->
<!--                  <div class="tick-right">-->
<!--                    <div class="tick"></div>-->
<!--                  </div>-->
<!--                  <div class="tick-right">-->
<!--                    <div class="tick"></div>-->
<!--                  </div>-->
<!--                </div>-->
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Não sou conformado. Não aceito como destino tudo o que me
                    acontece e faço de tudo para tentar mudar as coisas para melhor.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p1.q2">
                </range-slider>
                <div class="marks ticks">
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Sou atencioso, tenho empatia pelas pessoas e sinto prazer em
                    ajudá-las, tendo até dificuldade em dizer “não”.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p1.q3">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Acordo sempre motivado (mesmo às segundas feiras),
                    independentemente dos problemas.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p1.q4">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

              <div class="col-md-8 my-4">
                <div class="align-center">
                  <p class="form-control-label">Lido bem com ter pouco ou muito dinheiro, sendo que a falta dele
                    só me dá mais vontade de vencer.

                  </p>
                </div>
                <div class="marks">
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Totalmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Discordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Parcialmente</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>Concordo<br /> Totalmente</span>
                  </div>
                </div>
                <range-slider
                  @change="update()"
                  class="slider"
                  min="1"
                  max="4"
                  step="1"
                  v-model="p1.q5">
                </range-slider>
                <div class="marks ticks" >
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                  <div class="align-marks-mid">
                    <span>'</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="align-center mt-6">
              <base-button outline type="secondary" class="back-btn" @click="prevPage()">Voltar</base-button>
              <base-button type="secondary" native-type="submit">Avançar</base-button>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
    <!-- Page content -->


  </div>
</template>

<script>
  import 'vue-range-slider/dist/vue-range-slider.css'
  import RangeSlider from 'vue-range-slider'

export default {
  name: 'qa1',
  components: {
    RangeSlider,
  },
  data: () => ({
      validated: false,
      slider: 0,
      progressValue: 10,
      p1: {
        q1: 1,
        q2: 1,
        q3: 1,
        q4: 1,
        q5: 1,
      },
  }),
  methods: {
    prevPage () {
      this.$router.push('benchmark')
    },
    update () {
      window.localStorage.setItem("p1", JSON.stringify(this.p1))
    },
    async nextPage () {
      window.localStorage.setItem("p1", JSON.stringify(this.p1))
      console.log(this.p1)
      let sum = this.p1.q1+this.p1.q2+this.p1.q3+this.p1.q4+this.p1.q5
      window.localStorage.setItem("p1sum", JSON.stringify(sum))
      await this.$router.push('qa2')
    }

  },
  created() {
    let payload = window.localStorage.getItem("p1")

    if (payload != null) {
      this.p1 = JSON.parse(payload)
    }

  }
};
</script>
<style></style>
